import { render, staticRenderFns } from "./SystemInfo.vue?vue&type=template&id=40c21fd3&scoped=true&"
import script from "./SystemInfo.vue?vue&type=script&lang=js&"
export * from "./SystemInfo.vue?vue&type=script&lang=js&"
import style0 from "./SystemInfo.vue?vue&type=style&index=0&id=40c21fd3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c21fd3",
  null
  
)

export default component.exports